<template>
    <div>
        <v-list v-if="$store.state.current.user" dense>
            <!--<v-list-item class="px-2">
                <v-list-item-avatar>
                    <v-img src="https://pbs.twimg.com/profile_images/453658183135817729/W0DjKZ_A_400x400.png"></v-img>
                </v-list-item-avatar>
            </v-list-item>-->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="text-h6 text-truncate">{{$store.state.current.user.name}}</v-list-item-title>
                    <v-list-item-subtitle>{{$store.state.current.user.email}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            
            <v-list-item link to="/app/env">
                <v-list-item-content>
                    <v-list-item-title class="text-button text--white">{{$store.state.current.company.name}}</v-list-item-title>
                    <v-list-item-subtitle>{{$store.state.current.stage.name}}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{$store.state.current.role.name}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar>
                    <v-icon>mdi-repeat</v-icon>
                </v-list-item-avatar>
            </v-list-item>


        </v-list>
        <v-divider></v-divider>
        <v-list nav>
            <v-list-item v-for="op in $store.getters['current/getMenu']" :key="op.id" link :to="op.path">
                <v-list-item-icon>
                    <v-icon>{{op.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{op.name}}</v-list-item-title>
            </v-list-item>
            
        </v-list>
    </div>
  
</template>

<script>
export default {
    
}
</script>

<style>

</style>